export default __webpack_public_path__ + "static/media/H.23201e21.svg";